import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import Picture from '../Picture';
import PlayVideoIcon from '../Icons/PlayVideo';
import Modal from '../Modal';
import Video from '../Video';
import { useInView } from 'react-intersection-observer';

const FeaturedMedia = ({
  src = '',
  alt = '',
  mediaType = '',
  video = null,
  autoplay = false,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (autoplay) {
      setModalOpen(true);
    }
  }, []);

  return (
    <Styles
      ref={ref}
      className={`block-featured_media block-featured_media--${mediaType.toLowerCase()} ${
        isAnimated && 'isAnimated'
      } ${inView && 'active'}`}
    >
      <div
        className='inner'
        tabIndex='0'
        onKeyPress={e => {
          if (e.key === 'Enter') setModalOpen(true);
        }}
        onClick={() => setModalOpen(true)}
      >
        <Picture
          src={`${src}?w=808`}
          alt={alt}
          isResponsive
          sources={[
            {
              media: '(min-width: 1440px)',
              params: '?w=808',
              srcSet: src,
            },
            {
              media: '(min-width: 512px)',
              params: '?w=512',
              srcSet: src,
            },
            {
              media: '(max-width: 512px)',
              params: '?w=300',
              srcSet: src,
            },
          ]}
        />

        <div className='play-btn'>
          {mediaType === 'Video' && <PlayVideoIcon />}
        </div>

        {mediaType === 'Video' && video && video.content && modalOpen && (
          <Modal onClose={() => setModalOpen(false)}>
            <Video {...video}></Video>
          </Modal>
        )}
      </div>
    </Styles>
  );
};

FeaturedMedia.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  mediaType: PropTypes.string,
  video: PropTypes.shape({
    source: PropTypes.string,
    content: PropTypes.string,
  }),
  autoplay: PropTypes.bool,
  isAnimated: PropTypes.bool,
};

export default FeaturedMedia;
